import type { QuestionMarkingCriterion, QuestionMarkOutcome } from '@huoncroll/math-editors/marking';
import {
  markFullQuestion,
  markQuestionAnswer,
  type QuestionForMarking,
} from '@huoncroll/math-editors/marking';
import {
  isAiMarkingType,
  isManualMarkingType,
  resolveMarkingType,
  type MarkingTypeSource,
} from './markingType.ts';

export type {
  MarkingType,
  MarkingTypeSource,
} from './markingType.ts';
export {
  MARKING_TYPES,
  clientScoresMarkingType,
  isAiMarkingType,
  isDeterministicMarkingType,
  isManualMarkingType,
  resolveMarkingType,
} from './markingType.ts';

export type SubmittableQuestion = QuestionForMarking & {
  id: string;
  worked_solution?: string | null;
};

export const isAiMarkQuestion = (question: MarkingTypeSource): boolean =>
  isAiMarkingType(resolveMarkingType(question));

export const isManualMarkQuestion = (question: MarkingTypeSource): boolean =>
  isManualMarkingType(resolveMarkingType(question));

export const toSubmittableQuestion = (question: {
  id: string;
  type: string;
  marks?: number | null;
  answer?: string | null;
  unit?: string | null;
  answer_index?: number | null;
  marking_method?: string | null;
  deterministic_config?: QuestionForMarking['deterministic_config'];
  ai_config?: QuestionForMarking['ai_config'];
  worked_solution?: string | null;
}): SubmittableQuestion => {
  const markingType = resolveMarkingType(question);
  return {
    id: question.id,
    type: question.type === 'mc' || question.type === 'table' ? 'mc' : 'input',
    marks: Number(question.marks ?? 0),
    answer: question.answer,
    unit: question.unit,
    answer_index: question.answer_index,
    marking_method: markingType,
    deterministic_config: question.deterministic_config ?? {},
    ai_config: question.ai_config ?? {},
    worked_solution: question.worked_solution,
  };
};

export const scoreQuestionSubmission = (
  question: SubmittableQuestion,
  submission: {
    finalAnswer: string | null;
    selectedIndex?: number | null;
    workingSteps?: string[];
  },
  criteria: QuestionMarkingCriterion[] = [],
): QuestionMarkOutcome => {
  const resolved: SubmittableQuestion = {
    ...question,
    marking_method: resolveMarkingType(question),
  };
  if (criteria.length) {
    return markFullQuestion(resolved, submission, criteria);
  }
  return markQuestionAnswer(resolved, submission);
};
